import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CustomerLeafCollectionNewReport } from './Pages';

export const CustomerLeafCollectionReportNewRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CustomerLeafCollectionNewReport} />
       
    </Fragment>
)